import React from 'react';
import { profilePersonalInfoPage } from 'platform/forms-system/src/js/patterns/prefill';

const personalInfoPageConfig = {
  key: 'claimantInformation',
  title: 'Claimant information',
  path: 'claimant/information',
  depends: formData => formData?.claimantType !== 'VETERAN',
  dataAdapter: {
    ssnPath: 'claimantSocialSecurityNumber',
    // vaFileNumberPath: 'vaFileNumberLastFour',
  },
};

const personalInfoConfig = {
  name: { show: true, required: true },
  ssn: { show: true, required: false },
  //   vaFileNumber: { show: true, required: false },
  dateOfBirth: { show: true, required: true },
};
const { claimantInformation: claimantInformationWithVaFileNumber } =
  profilePersonalInfoPage({
    ...personalInfoPageConfig,
    personalInfoConfig,
  });

const { claimantInformation: claimantInformationWithoutVaFileNumber } =
  profilePersonalInfoPage({
    ...personalInfoPageConfig,
    personalInfoConfig: {
      ...personalInfoConfig,
      vaFileNumber: { show: false, required: false },
    },
  });
export const hasVaFileNumber = formData =>
  !!(formData?.veteranVaFileNumberLastFour || formData?.vaFileNumber);
const getApplicantInformationPage = formData =>
  hasVaFileNumber(formData)
    ? claimantInformationWithVaFileNumber
    : claimantInformationWithoutVaFileNumber;

export const ClaimantInformationPage = props => {
  const { CustomPage } = getApplicantInformationPage(props.data);
  return <CustomPage {...props} />;
};

export const ClaimantInformationReview = props => {
  const { CustomPageReview } = getApplicantInformationPage(props.data);
  return <CustomPageReview {...props} />;
};
/** @type {PageSchema} */
export default {
  ...claimantInformationWithVaFileNumber,
  CustomPage: ClaimantInformationPage,
  CustomPageReview: ClaimantInformationReview,
};
